module.exports = __webpack_public_path__ + "img/color2.2b63ddb8.png";